import { Controller } from "stimulus"

// Slide-over drawer for adding products to a category on the menu page.
// A single drawer is reused for every category; the "+ Add products" buttons
// pass the category's picker URL + name via data attributes.
export default class extends Controller {

  static targets = [ "panel", "backdrop", "content", "title" ]

  connect() {
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  open(event) {
    event.preventDefault()
    const button = event.currentTarget
    const url = button.dataset.pickerUrl
    const title = button.dataset.pickerTitle || ""

    if (this.hasTitleTarget) this.titleTarget.textContent = title
    this.showPanel()
    this.loadContent(url)
  }

  showPanel() {
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.add("opacity-100")
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.remove("opacity-100")
    this.panelTarget.classList.add("translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    document.body.classList.remove("overflow-hidden")
  }

  loadContent(url) {
    this.contentTarget.innerHTML = this.spinnerHtml()
    fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "text/html" },
      credentials: "same-origin"
    })
      .then(response => {
        if (!response.ok) throw new Error("Request failed")
        return response.text()
      })
      .then(html => { this.contentTarget.innerHTML = html })
      .catch(() => { this.contentTarget.innerHTML = this.errorHtml() })
  }

  filter(event) {
    const query = event.target.value.trim().toLowerCase()
    const items = this.contentTarget.querySelectorAll("[data-product-name]")
    let visible = 0
    items.forEach(item => {
      const match = query === "" || (item.dataset.productName || "").includes(query)
      item.classList.toggle("hidden", !match)
      if (match) visible++
    })
    const noResults = this.contentTarget.querySelector("[data-product-picker-target='noResults']")
    if (noResults) noResults.classList.toggle("hidden", visible !== 0)
  }

  spinnerHtml() {
    return `<div class="flex h-full items-center justify-center py-16">
      <svg class="h-6 w-6 animate-spin text-primary-600" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
    </div>`
  }

  errorHtml() {
    const message = this.element.dataset.errorText || "Something went wrong. Please try again."
    return `<div class="p-6 text-center text-sm text-red-600">${message}</div>`
  }

}
